import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Fancybox from "./Fancybox";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const GallerySlider = ({ images }) => {

    const [current, setCurrent] = useState(0);
    const [slidesToShow, setSlidesToShow] = useState(
        window.innerWidth < 768 ? 1 : 2
    );

    const sliderRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            setSlidesToShow(window.innerWidth < 768 ? 1 : 2);
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 2, // Desktop
        slidesToScroll: 1,
        cssEase: "linear",
        beforeChange: (_, next) => {
            setCurrent(next);
        },
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    if (!images?.length) return null;

    const totalImages = images.length;

    // Total possible slider positions
    const totalSteps = Math.max(1, totalImages - slidesToShow + 1);

    // Current position (1-based)
    const currentStep = current + 1;

    // Progress percentage
    const progress = ((current + 1) / totalSteps) * 100;

    const handleProgressClick = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();

        const clickX = e.clientX - rect.left;

        const segmentWidth = rect.width / totalSteps;

        const targetSlide = Math.floor(clickX / segmentWidth);

        sliderRef.current?.slickGoTo(targetSlide);
        setCurrent(targetSlide);
    };

    return (
        <Fancybox>
        <div className="slider_wrapper gallery_slider">
            <Slider ref={sliderRef} {...settings}>
                {images.map((image, index) => (
                    <div key={index} className="slider_slide_item">
                        <a href={`https://backend.bgzurlinden.ch${image?.url}`} data-fancybox="gallery">
                            <img src={`https://backend.bgzurlinden.ch${image?.url}`} className="w-100" alt={`Gallery ${index + 1}`} />
                        </a>
                    </div>
                ))}
            </Slider>

            <div className="slider-count-progress">
                <div className="slide_item_count">
                    <span className="current">
                        {current < 10 ? `0${current + 1}` : current + 1}
                    </span>
                    {" / "}
                    <span className="total">
                        {totalSteps < 10 ? `0${totalSteps}` : totalSteps}
                    </span>
                </div>

                <div className="progress progress-segmented" onClick={handleProgressClick} style={{cursor: 'pointer'}}>
                    {Array.from({ length: totalSteps }).map((_, index) => (
                        <span key={index} className="progress-divider" />
                    ))}
                    <div className="progress-bar" style={{ width: `${progress}%` }} />
                </div>
            </div>
        </div>
        </Fancybox>
    );
};

export default GallerySlider;